import { ColorEnum } from '@/constants/color'
import MinusIcon from '@/features/ui/icons/components/MinusIcon'
import PlusIcon from '@/features/ui/icons/components/PlusIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface ModifierRowProps {
    type: 'addition' | 'removal'
    label: string
    price?: string
}

const ModifierRow: FC<ModifierRowProps> = ({ type, label, price }) => {
    const { styles } = useStyles(stylesheet)
    const Icon = type === 'addition' ? PlusIcon : MinusIcon

    return (
        <View style={styles.modifier}>
            <View style={[styles.modifierIcon, styles.modifierIconType(type)]}>
                <Icon
                    width={16}
                    height={16}
                    fill={type === 'addition' ? ColorEnum.EMERALD_700 : ColorEnum.BRICK_600}
                />
            </View>
            <Typography.Description style={styles.modifierLabel}>{label}</Typography.Description>
            {price && (
                <Typography.Description style={styles.modifierPrice}>
                    {price}
                </Typography.Description>
            )}
        </View>
    )
}

const stylesheet = createStyleSheet({
    modifier: {
        minHeight: 20,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
    },
    modifierLabel: {
        flex: 1,
        minWidth: 0,
    },
    modifierPrice: { width: 105, textAlign: 'right' },
    modifierIcon: {
        width: 20,
        height: 20,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4,
    },
    modifierIconType: (type: ModifierRowProps['type']) => ({
        backgroundColor: type === 'addition' ? ColorEnum.EMERALD_200 : ColorEnum.BRICK_200,
    }),
})

export default ModifierRow
